import React from 'react';

import { AccountScreenContainer, AccountScreenTitle } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

import { SkeletonLoadingContentLG } from './AccountSkeletonLoading';

export const AccountFavoritesLoading = () => {
  const { t } = useLocalizationContext();

  return (
    <AccountScreenContainer screen="favorites">
      <AccountScreenTitle title={t('account.favorites.title')} />

      {/* Favorites */}
      <SkeletonLoadingContentLG />
      <SkeletonLoadingContentLG />
      <SkeletonLoadingContentLG />
      <SkeletonLoadingContentLG />
    </AccountScreenContainer>
  );
};
